import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function StockDef({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/BuyAndSellStock");
    };

    const goPrev = () => {
        navigate("/InvestPortfolio");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Stock
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Stocks represent ownership of a company.  Each unit of stock, called a share, 
                </div>
                <div className="text-[#000000] text-3xl">
                    is worth some percent of a company (usually very small), and the more share you 
                </div>
                <div className="text-[#000000] text-3xl">
                    own, the more of the company you own.  Corporations issue stock to raise funds 
                </div>
                <div className="text-[#000000] text-3xl">
                    to operate their business and can buy back their own stock.  Stocks are volatile 
                </div>
                <div className="text-[#000000] text-3xl">
                    and have a high associated risk, but they also generally give the most returns in the 
                </div>
                <div className="text-[#000000] text-3xl">
                    long run.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    There are 2 types of stock:  common and preferred.  Holding common stock 
                </div>
                <div className="text-[#000000] text-3xl">
                    allows the holder to vote at shareholder’s meetings, but holding preferred stock 
                </div>
                <div className="text-[#000000] text-3xl">
                    means that the holder gets paid before common stockholders and are prioritized 
                </div>
                <div className="text-[#000000] text-3xl">
                    if the corporation goes bankrupt.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}